module.exports = __webpack_public_path__ + "img/treehouse.846963a6.png";